function hasWindow() {
  return typeof window !== `undefined`;
}

export default hasWindow;
